'use strict';

// DOM helpers: view switching, rendering, toasts. All guard against missing
// elements so the module is harmless when loaded on a non-app page (test harnesses).

// Per-view display value when shown (dashboard is a CSS grid; the rest are flex
// columns). Using '' here would fall back to the stylesheet, where .dashboard-view
// is display:none — so we must set the concrete value.
const VIEW_DISPLAY = { auth: 'flex', backup: 'flex', unlock: 'flex', dashboard: 'grid' };
const VIEWS = Object.keys(VIEW_DISPLAY);

function $(id) { return document.getElementById(id); }
function setText(id, text) { const el = $(id); if (el) el.textContent = text; }
function hasUI() { return !!$('view-auth'); }

function show(name) {
  for (const v of VIEWS) { const el = $('view-' + v); if (el) el.style.display = v === name ? VIEW_DISPLAY[v] : 'none'; }
}

function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

function toast(message, kind = 'info') {
  const box = $('toasts');
  if (!box) { console.log('[toast]', kind, message); return; }
  const el = document.createElement('div');
  el.className = 'toast toast-' + kind;
  el.textContent = message;
  box.appendChild(el);
  setTimeout(() => { el.classList.add('toast-out'); setTimeout(() => el.remove(), 300); }, 3600);
}

function renderMnemonic(phrase) {
  const grid = $('mnemonic-grid');
  if (!grid) return;
  grid.innerHTML = '';
  phrase.split(' ').forEach((w, i) => {
    const d = document.createElement('div');
    d.className = 'mword';
    d.innerHTML = '<span class="mword-i">' + (i + 1) + '</span>' + escapeHtml(w);
    grid.appendChild(d);
  });
}

function renderDashboard(state) {
  const k = state.keys;
  if (!k) return;
  setText('dash-email', state.email || '');
  setText('dash-did', state.did || '');
  const roles = [['identity', k.identity], ['finance', k.finance], ['tokens', k.tokensOrdinals]];
  for (const [name, key] of roles) {
    setText('kc-' + name + '-addr', key.address);
    setText('kc-' + name + '-path', key.path);
  }
}

function badgeFor(item) {
  if (item.revoked) return '<span class="vc-badge" style="color:#ef4444;background:rgba(239,68,68,.1)">Revoked</span>';
  if (item.ok) return '<span class="vc-badge" style="color:#10b981;background:rgba(16,185,129,.1)">Verified VC</span>';
  return '<span class="vc-badge" style="color:#ef4444;background:rgba(239,68,68,.1)">Invalid</span>';
}

function addFeedItem(item) {
  const feed = $('attest-feed');
  if (!feed) return;
  const el = document.createElement('div');
  el.className = 'feed-item';
  el.dataset.hash = item.hash || '';
  el.innerHTML =
    '<div class="verified-avatar"><i class="fa-solid fa-feather"></i>' +
    '<div class="badge-check"><i class="fa-solid fa-check"></i></div></div>' +
    '<div style="flex-grow:1;min-width:0">' +
    '<div style="display:flex;justify-content:space-between;gap:1rem;align-items:center">' +
    '<strong style="font-size:.9rem">Authentic Content Credential</strong>' + badgeFor(item) + '</div>' +
    '<p style="font-size:.85rem;color:var(--text-muted);word-break:break-word">' + escapeHtml(item.text) + '</p>' +
    '<p style="font-size:.68rem;color:var(--text-muted);font-family:monospace;word-break:break-all">sha256 ' + escapeHtml((item.hash || '').slice(0, 32)) + '…</p>' +
    '<div class="feed-actions">' +
    '<button class="feed-copy"><i class="fa-regular fa-copy"></i> Copy VC</button>' +
    '<a href="/verify.html" target="_blank" rel="noopener">Verify publicly <i class="fa-solid fa-arrow-up-right-from-square" style="font-size:.65rem"></i></a>' +
    (item.revoked ? '' : '<button class="feed-revoke">Revoke</button>') +
    '</div></div>';
  const copyBtn = el.querySelector('.feed-copy');
  if (copyBtn) copyBtn.dataset.jwt = item.jwt || '';
  feed.prepend(el);
  return el;
}

module.exports = { $, setText, hasUI, show, toast, renderMnemonic, renderDashboard, addFeedItem };
